import { formatDate, formatDateToDDMMYYYY } from '@/utils/dateFormat'

export function parseISODate(value: string | null | undefined): Date | null {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function toISODateString(date: Date | null): string | undefined {
  if (!date) return undefined
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatShippingPeriod(
  startDate: Date | string | null | undefined,
  endDate: Date | string | null | undefined,
  legacyDeliveryPeriod?: string | null
): string {
  const start = startDate instanceof Date ? formatDate(startDate) : formatDateToDDMMYYYY(startDate)
  const end = endDate instanceof Date ? formatDate(endDate) : formatDateToDDMMYYYY(endDate)

  if (start && end) return `${start} - ${end}`
  if (start) return start
  if (end) return end
  if (legacyDeliveryPeriod?.trim()) return legacyDeliveryPeriod.trim()
  return '-'
}

export function formatShippingPeriodForSave(startDate: Date | null, endDate: Date | null): string | undefined {
  if (!startDate && !endDate) return undefined
  return formatShippingPeriod(startDate, endDate)
}
